/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentMetadataDto } from '../../models/document-metadata-dto';

export interface MergeDocuments$Params {

/**
 * The technical id of the customer
 */
  customerId: number;

/**
 * The list of document ids to be merged
 */
  documentIds: Array<number>;

/**
 * The risk assessment document to which all the above documents shall be merged (appended)
 */
  riskAssessmentDocumentId: number;
}

export function mergeDocuments(http: HttpClient, rootUrl: string, params: MergeDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentMetadataDto>> {
  const rb = new RequestBuilder(rootUrl, mergeDocuments.PATH, 'post');
  if (params) {
    rb.query('customerId', params.customerId, {});
    rb.query('documentIds', params.documentIds, {});
    rb.query('riskAssessmentDocumentId', params.riskAssessmentDocumentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentMetadataDto>;
    })
  );
}

mergeDocuments.PATH = '/documents/merge-documents';
